import App from './App.svelte';
import {findRepoId} from "./helpers";

const getTarget = () => {
    const pathname = location.pathname
    if (pathname.indexOf('other_objects') >= 0) {
        return document.querySelector('.content-pane.container-fluid')
    }
    return document.querySelector(':is(body.action-show, body.action-edit) .record-pane')
}

let intervalId
let app
let target

window.InjectApp = function () {
    target = getTarget()

    if (target) {
        app = new App({target, props: {}})
    } else {
        intervalId = setInterval(() => {
            target = getTarget()
            if (target) {
                clearInterval(intervalId)
                app = new App({target, props: {}})
                return
            }

        }, 1000)
    }
}

window.addEventListener('hashchange', () => {
    clearInterval(intervalId)
    if (location.hash.indexOf('tree::resource') >= 0 || location.hash.indexOf('tree::archival_object') >= 0) {
        target && target.removeChild(target.lastChild)
        // change later to check if hash based content swap is ready for injection of new app
        setTimeout(() => InjectApp(), 3000)
    }
})